import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { TableModule } from "primeng/table";
import { ConfirmationService, DataTableModule, ProgressSpinnerModule, TreeTableModule } from "primeng/primeng";

import { AutoCompleteModule } from "primeng/autocomplete";
import { FileUploadModule } from "primeng/fileupload";
import { DropdownModule } from "primeng/dropdown";
// import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { CalendarModule } from "primeng/calendar";
import { MultiSelectModule } from "primeng/multiselect";
import { GrowlModule } from "primeng/growl";
import { CheckboxModule } from "primeng/checkbox";
import { DialogModule } from "primeng/dialog";
import { TooltipModule } from "primeng/tooltip";
import { AccordionModule } from "primeng/accordion";
import { StepsModule } from "primeng/steps";
import { AppComponent } from "./app.component";
import { UserService } from "./shared/user.service";
//import { Page1Service } from "./page1/Page1.Service";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { UserComponent } from "./user/user.component";
import { SignInComponent } from "./user/sign-in/sign-in.component";
import { HomeComponent } from "./home/home.component";
import { SignUpComponent } from "./user/sign-up/sign-up.component";
import { appRoutes } from "./routes";
import { AuthGuard } from "./auth/auth.guard";
import { AuthInterceptor } from "./auth/auth.interceptor";
import { Page1Component } from "./page1/page1.component";
import { TransferDetailComponent } from "./TransferDetail/transfer-detail.component";
import { TransferDataService } from "./transfer-data.service";
import { EmployeeDepositsComponent } from "./employee-deposits/employee-deposits.component";
import { EmployeeDepositsService } from "./service/employee-deposits.service";
import { UploadXmlFileComponent } from "./upload-xml-file/upload-xml-file.component";
import { FeedbackUploadComponent } from "./feedback-upload/feedback-upload.component";
import { FurloughUploadComponent } from "./furlough-upload/furlough-upload.component";
import { UploadXmlFileService } from "./service/upload-xml-file.service";
import { ListUserComponent } from "./user-management/list-user/list-user.component";
import { UserManagementService } from "./service/user-management.service";
import { UpdateUserComponent } from "./user-management/update-user/update-user.component";
import { CreateUserComponent } from "./user-management/create-user/create-user.component";
import { FileStatusComponent } from "./file-status/file-status.component";
import { FileStatusService } from "./service/file-status.service";
import { FeedbackStatusFollowUpComponent } from "./feedback-status-followup/feedback-status-followup.component";
import { FeedbackStatusFollowUpTotalsComponent } from "./feedback-status-followup-totals/feedback-status-followup-totals.component";
import { FeedbackStatusFollowUpService } from "./service/feedback-status-followup.service";
import { MenuComponent } from "./menu/menu.component";
import { UserDetailComponent } from "./user/user-detail/user-detail.component";
import { MainPageComponent } from "./main-page/main-page.component";
import { ErrorPageComponent } from "./error-page/error-page.component";
import { FeedbackComponent } from "./feedback/feedback.component";
import { FeedbackErrorEmployeeComponent } from "./feedback-error-employee/feedback-error-employee.component";
import { FeedbackErrorFileComponent } from "./feedback-error-file/feedback-error-file.component";
import { ChangeCurrentCustomerComponent } from "./change-current-customer/change-current-customer.component";
import { PaymentsReportComponent } from "./payments-report/payments-report.component";
import { AdminLogsComponent } from "./admin-logs/admin-logs.component";
import { PaymentReportService } from "./service/payment-report.service";
import { FeedbackService } from "./service/feedback.service";
import { FeedbackErrorService } from "./service/feedback-error.service";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { CustomerRefreshComponent } from "./customer-refresh/customer-refresh.component";
import { Form161Component } from "./form161/form161.component";
import { Form161Service } from "./service/form161.service";
import { CustomerListComponent } from "./customer-list/customer-list.component";
import { CustomerListReminderComponent } from "./customer-list-reminder/customer-list-reminder.component";
import { CustomerListLossWorkCapacityComponent } from "./customer-list-loss-work-capacity/customer-list-loss-work-capacity.component";
import { CustomerService } from "./service/customer.service";
import { FundInstitutionListComponent } from "./fund-institution-list/fund-institution-list.component";
import { FundinstitutionService } from "./service/fundinstitution.service";
import { BankComponent } from "./bank/bank.component";
import { BankService } from "./service/bank.service";
import { BankCreateComponent } from "./bank-create/bank-create.component";
import { BankUpdateComponent } from "./bank-update/bank-update.component";
import { FundinstitutionUpdateComponent } from "./fundinstitution-update/fundinstitution-update.component";
import { FundinstitutionCreateComponent } from "./fundinstitution-create/fundinstitution-create.component";
import { MainPageService } from "../app/service/main-page.service";
import { FileListComponent } from "./MSVFile/file-list/file-list.component";
import { MsvfileService } from "../app/service/msvfile.service";
import { CompleteDataComponent } from "./MSVFile/complete-data/complete-data.component";
import { TabViewModule } from "primeng/tabview";
import { PanelModule } from "primeng/panel";
import { PaginatorModule } from "primeng/paginator";
import { SelectButtonModule } from "primeng/selectbutton";
import { CustomersNotReportedComponent } from "../app/customers-not-reported/customers-not-reported.component";
import { DatePipe } from "@angular/common";
import { PreformanceStatusComponent } from "./preformance-status/preformance-status.component";
import { PreformanceStatusDetailedComponent } from "./preformance-status-detailed/preformance-status-detailed.component";
import { PreformanceStatusService } from "./service/preformance-status.service";
import { FeedbackStatusSFSyncComponent } from "./feedback-status-sf-sync/feedback-status-sf-sync.component";
import { FeedbackStatusSFSyncService } from "./service/feedback-status-sf-sync.service";
import { CompareBaseDetailsComponent } from "./compare-base-details/compare-base-details.component";
import { BaseDataService } from "./service/base-data.service";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { Form161FormalyComponent } from "./form161-formaly/form161-formaly.component";
import { Form161FormalyService } from "./service/form161Formaly.service";
import { Form161FormalyEmployeeComponent } from "./form161-formaly-employee/form161-formaly-employee.component";
import { Form161FormalyListComponent } from './form161-forlmaly-list/form161-forlmaly-list.component';
import { SettingsComponent } from "./settings/settings.component";
import { SettingsService } from "./service/settings.service";
import { XmlFileEditorComponent } from "./xml-file-editer/xml-file-editor.component";
import { XmlFileEditorService } from "./service/xml-file-editor.service";

@NgModule({
  declarations: [
    AppComponent,
    SignUpComponent,
    UserComponent,
    SignInComponent,
    HomeComponent,
    Page1Component,
    TransferDetailComponent,
    EmployeeDepositsComponent,
    UploadXmlFileComponent,
    FeedbackUploadComponent,
    FurloughUploadComponent,
    ListUserComponent,
    UpdateUserComponent,
    CreateUserComponent,
    FileStatusComponent,
    FeedbackStatusFollowUpComponent,
    FeedbackStatusFollowUpTotalsComponent,
    MenuComponent,
    UserDetailComponent,
    MainPageComponent,
    ErrorPageComponent,
    FeedbackComponent,
    FeedbackErrorEmployeeComponent,
    FeedbackErrorFileComponent,
    ChangeCurrentCustomerComponent,
    PaymentsReportComponent,
    AdminLogsComponent,
    CustomerRefreshComponent,
    Form161Component,
    CustomerListComponent,
    CustomerListReminderComponent,
    CustomerListLossWorkCapacityComponent,
    FundInstitutionListComponent,
    BankComponent,
    BankCreateComponent,
    BankUpdateComponent,
    FundinstitutionUpdateComponent,
    FundinstitutionCreateComponent,
    FileListComponent,
    CompleteDataComponent,
    CustomersNotReportedComponent,
    PreformanceStatusComponent,
    PreformanceStatusDetailedComponent,
    FeedbackStatusSFSyncComponent,
    CompareBaseDetailsComponent,
    Form161FormalyComponent,
    Form161FormalyEmployeeComponent,
    Form161FormalyListComponent,
    SettingsComponent,
    XmlFileEditorComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    TableModule,
    AutoCompleteModule,
    FileUploadModule,
    DropdownModule,
    CalendarModule,
    MultiSelectModule,
    GrowlModule,
    CheckboxModule,
    DialogModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    TooltipModule,
    AccordionModule,
    DataTableModule,
    TabViewModule,
    PanelModule,
    PaginatorModule,
    StepsModule,
    SelectButtonModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    TreeTableModule
  ],
  providers: [
    UserService,
    //Page1Service,
    AuthGuard,
    TransferDataService,
    EmployeeDepositsService,
    UploadXmlFileService,
    UserManagementService,
    FileStatusService,
    FeedbackStatusFollowUpService,
    PaymentReportService,
    FeedbackService,
    FeedbackErrorService,
    Form161Service,
    CustomerService,
    FundinstitutionService,
    BankService,
    MainPageService,
    MsvfileService,
    DatePipe,
    PreformanceStatusService,
    FeedbackStatusSFSyncService,
    BaseDataService,
    ConfirmationService,
    Form161FormalyService,
    SettingsService,
    XmlFileEditorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/app.module.ts